import type { TOC } from '@ember/component/template-only';
import { PrismBadge } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSidebarItemSignature {
  Args: {
    isValid?: boolean;
    name: string;
  };
}

const HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSidebarItem =
  <template>
    <div
      class="tab-smart-compset__sidebar__item flex flex-row items-center justify-between"
    >
      {{@name}}

      {{#unless @isValid}}
        <PrismBadge
          @iconName="warning"
          @isSmall={{true}}
          @label={{t
            "benchmark_insight.competitors.smart_compset.warning.note"
          }}
          @type="warning"
        />
      {{/unless}}
    </div>
  </template> satisfies TOC<HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSidebarItemSignature>;

export default HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSidebarItem;
